(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityTemplateAcl', EntityTemplateAcl);

    EntityTemplateAcl.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvEntityTemplateAcl
     *
     * @description
     * Shows access control list (ACL) for an entity template, and provides user interface for editing.
     *
     * # Scope Properties
     * {array} users
     * {object} acl - Object detailing access control list for the entity template, with properties:
     *   {bool} GrantAll - True if default is to grant all users
     *   {array} GrantUsers - Array of {number} user IDs for users that are explicitly granted access
     *   {array} DenyUsers - Array of {number} user IDs for users that are explicitly denied access
     */
    function EntityTemplateAcl() {
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/EntityTemplate/entity-template-acl.tmpl.html',
            scope: {
                users: '=',
                acl: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.defaultOptions = [
                {
                    label: 'Allow',
                    value: true
                },
                {
                    label: 'Deny',
                    value: false
                }
            ];

            scope.userHasGrant = function (userId) {
                return _.indexOf(scope.acl.GrantUsers, userId) != -1 ||
                    (scope.acl.GrantAll && _.indexOf(scope.acl.DenyUsers, userId) == -1);
            };

            scope.userHasDeny = function (userId) {
                return _.indexOf(scope.acl.DenyUsers, userId) != -1 ||
                    (!scope.acl.GrantAll && _.indexOf(scope.acl.GrantUsers, userId) == -1);
            };

            scope.userHasOverride = function (userId) {
                return _.indexOf(scope.acl.GrantUsers, userId) != -1 || _.indexOf(scope.acl.DenyUsers, userId) != -1;
            };

            scope.userGrantClick = function (userId) {
                if (scope.userHasGrant(userId)) {
                    _.pull(scope.acl.GrantUsers, userId);
                } else {
                    _.pull(scope.acl.DenyUsers, userId);
                    scope.acl.GrantUsers.push(userId);
                }
            };

            scope.userDenyClick = function (userId) {
                if (scope.userHasDeny(userId)) {
                    _.pull(scope.acl.DenyUsers, userId);
                } else {
                    _.pull(scope.acl.GrantUsers, userId);
                    scope.acl.DenyUsers.push(userId);
                }
            };

            scope.userOverrideClick = function (userId) {
                if (scope.userHasOverride(userId)) {
                    _.pull(scope.acl.GrantUsers, userId);
                    _.pull(scope.acl.DenyUsers, userId);
                } else {
                    if (scope.acl.GrantAll) {
                        scope.acl.GrantUsers.push(userId);
                    } else {
                        scope.acl.DenyUsers.push(userId);
                    }
                }
            };
        }
    }
})();
